import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { createPositions } from 'scenes/Users/AdminUsers/Positions/sources/positions';

import { create } from '../queryKeyFactory';

export const useCreatePosition = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const createMutation = useMutation(create(), createPositions, {
    successMessage: () => 'Position created',
  });

  const handleCreate = async () => {
    const name = await showModal({
      title: 'Add Position',
      withTextField: true,
      textFieldRequired: true,
      textFieldPlaceholder: 'Name',
      label: 'Name',
      confirmActionLabel: 'Create',
    });

    return await createMutation.mutateAsync({ name });
  };

  return [handleCreate, createMutation];
};
